/** @format */

export enum ShippingMethod {
    COLLECTION = 'collection',
    DROPOFF = 'dropoff',
}

export enum PrinterOption {
    PRINTER = 'printer',
    PRINTERLESS = 'printerless',
}

export enum ShippingOptionType {
    SHIPPING = 'shipping',
    COLLECTION = 'collection',
}

export enum ShippingOptionTypeEnum {
    SHIPPING = 1,
    COLLECTION = 3,
}

export const germanShippingHelpArticle =
    'https://intercom.help/mpbcom-de/de/articles/4359949-was-sind-meine-lieferoptionen';
